module.exports = __webpack_public_path__ + "img/sf_logo.9a04ba47.png";